import { useEffect } from "react";
import ReactGA from "react-ga4";

declare interface DataLayerWindow extends Window {
  GA_INITIALIZED?: boolean;
}
declare const window: DataLayerWindow;

export const useGoogleAnalyticsPageView = (eventId: string) => {
  useEffect(() => {
    if (
      process.env.NODE_ENV === "production" &&
      typeof window !== "undefined" &&
      window.GA_INITIALIZED
    ) {
      ReactGA.send({ hitType: "pageview", event_id: eventId });
    }
  }, [eventId]);
};
